// extracted by mini-css-extract-plugin
export default {"textBase":"text_textBase__IrgJP"};